import { Button, Col, message, Popconfirm, Row } from 'antd';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
	SCHEDULE_TECH_STATUSES,
	TECH_SCHEDULED_STATUSES,
	WORK_ORDER_STATUSES,
} from '../../../constants/WorkOrderStatuses';
import {
	acceptContractorWorkOrder,
	acceptWorkOrderForSupplier,
	declineContractorWorkOrder,
	declineWorkOrderForPrivateSupplier,
	declineWorkOrderForSupplier,
	manualCheckInServiceCallForContractor,
	manualCheckInServiceCallForSupplier,
	manualCheckOutServiceCallForContractor,
	manualCheckOutServiceCallForSupplier,
	rescheduleServiceCallForContractor,
	rescheduleServiceCallForSupplier,
	scheduleServiceCallForContractor,
	scheduleServiceCallForSupplier,
	techEnRouteContractorWorkOrder,
	techEnRouteServiceCallForSupplier,
	updateContractWorkOrder,
	workOrdersRestCrudThunksForSupplier,
} from '../../../thunks/work_orders_thunks';
import {
	disabledByAnotherAction,
	isCheckInModalMandatory,
	nullSafeGet,
	nullSafeGetOrElse,
	stopDefaultEvents,
} from '../../../utils/DataAccessUtils';
import DeclineWorkOrderForm from '../../decline_workorder_form/DeclineWorkOrderForm';
import ManualCheckInModalForm from '../../manual_checkin_modal_form/ManualCheckInModalForm';
import ManualCheckOutModalForm from '../../manual_checkout_modal_form/ManualCheckOutModalForm';
import ScheduleServiceCallModalForm from '../../schedule_service_call_modal_form/ScheduleServiceCallModalForm';
import WorkOrderRowDisplay from '../../work_order_row_display/WorkOrderRowDisplay';
import { getLinkWIthBackLinkParams } from '../../../utils/HistoryUtils';
import { updateWorkOrderResolutionTypeForSupplier } from '../../../thunks/resolution_types_thunks';
import {
	getContractorOrWorkOrderId,
	getSanitisedWorkOrder,
	getWorkOrderArchivalKey,
	isAValidAndParitalWorkOrder,
} from '../../../utils/WorkOrderUtils';
import TransferWorkOrder from '../../transfer_work_order/TransferWorkOrder';
import posthog from 'posthog-js';
import AccessPermissionChecker from '../../common/AccessPermissionChecker';
import { PERMISSION_NAMES } from '../../../utils/AuthUtils';
import {
	clampCheckOutToCheckIn,
	formatDateForLocationTimeZone,
} from '../../../utils/DataFormatterUtils';

require('./WorkOrderTableRow.less');

class WorkOrderTableRow extends React.Component<any, any> {
	formRefs: any = {
		scheduleServiceCallForm: null,
		rescheduleServiceCallForm: null,
		manualCheckInForm: null,
		manualCheckOutForm: null,
	};
	constructor(props) {
		super(props);
		this.state = { modal: null, actionButtonLoading: null };
	}
	saveFormRef = (formName) => (formRef) => {
		this.formRefs[formName] = formRef;
	};

	ensureFullWorkOrder = async (workOrder, actionKey) => {
		const { getFullWorkOrder } = this.props;

		if (isAValidAndParitalWorkOrder(workOrder)) {
			if (this.state.actionButtonLoading) {
				return workOrder;
			}

			this.setState({ actionButtonLoading: actionKey });
			try {
				const fullWorkOrder = await getFullWorkOrder(workOrder.id);
				return getSanitisedWorkOrder(fullWorkOrder, true);
			} catch (error) {
				message.error('Failed to load work order details. Please try again.');
				this.setState({ actionButtonLoading: null });
				throw error;
			}
		}

		return workOrder;
	};

	withFullWorkOrder = (actionKey, action) => {
		return async (...args) => {
			const workOrder = getSanitisedWorkOrder(this.props.record, true);
			const fullWorkOrder = await this.ensureFullWorkOrder(workOrder, actionKey);
			return action(fullWorkOrder, ...args);
		};
	};

	render() {
		const {
			record,
			currentUser,
			handleArchive,
			refreshTable = () => {},
			acceptWorkOrder,
			scheduleServiceCall,
			unarchiveWorkOrder,
			rescheduleServiceCall,
			location,
			backText,
			updateWorkOrderPartially,
			targetCollectionName,
			updateWorkOrderResolutionType,
			actions,
			isClientView,
			manualCheckInForContractor,
			updateSubContractorInfo,
			declineContractorWorkOrder,
			acceptContractorWorkOrder,
			manualCheckOutForContractor,
			techEnRouteWorkOrder,
		} = this.props;
		const BACK_TEXT = backText || 'Back to work orders';
		const isPrivateSupplier = nullSafeGet('facility.status', currentUser) === 'private';

		const workOrder = getSanitisedWorkOrder(record, true);

		const isTechEnRouteEnabled = posthog.isFeatureEnabled('tech-enroute-status');

		const { actionButtonLoading } = this.state;

		const getWorkOrderActions = () => {
			if (workOrder === undefined) return [];
			if (actions) return actions;
			const unarchive = (
				<div className={'ActionWrapper'}>
					<Button
						className={'ActionButton'}
						key="unarchive"
						onClick={(e) =>
							unarchiveWorkOrder(workOrder).then((e) => {
								refreshTable(location);
							})
						}
					>
						<i className="icons8-font icons8-trash-can"></i> Unarchive
					</Button>
				</div>
			);
			if (workOrder[getWorkOrderArchivalKey(currentUser)]) {
				return [unarchive];
			}

			const internalTechConfig =
				currentUser && currentUser.facility && currentUser.facility.internalTechConfig;

			const { allowedToTransferWork, allowedToDenyWork } = internalTechConfig || {
				allowedToTransferWork: true,
				allowedToDenyWork: false,
			};

			const differentAssignedSupplier = isPrivateSupplier
				? nullSafeGet('facility.id', currentUser) !== workOrder.supplierFacilityId
				: false;

			const accept = (
				<div className={'ActionWrapper'}>
					<Button
						className={'ActionButton'}
						key="accept"
						type="primary"
						ghost={true}
						onClick={this.withFullWorkOrder('accept', (fullWorkOrder, e) => {
							const action = nullSafeGet('contractorWo', fullWorkOrder)
								? acceptContractorWorkOrder(fullWorkOrder)
								: acceptWorkOrder(fullWorkOrder, e);
							action
								.then(() => refreshTable(location))
								.finally(() => this.setState({ actionButtonLoading: null }));
						})}
						loading={actionButtonLoading === 'accept'}
						disabled={disabledByAnotherAction(actionButtonLoading, 'accept')}
					>
						<i className="icons8-font icons8-green-check-mark"></i> Accept
					</Button>
				</div>
			);
			const decline = (
				<div className={'ActionWrapper'} onClick={(e) => e.stopPropagation()}>
					<Popconfirm
						onConfirm={this.withFullWorkOrder('decline', (fullWorkOrder, e) => {
							e.stopPropagation();
							e.preventDefault();
							if (nullSafeGet('contractorWo', fullWorkOrder)) {
								declineContractorWorkOrder(fullWorkOrder)
									.then(() => refreshTable(location))
									.finally(() => this.setState({ actionButtonLoading: null }));
							} else {
								this.setState({ actionButtonLoading: null, modal: 'declineWorkOrderFormVisible' });
							}
						})}
						placement="topLeft"
						title="Are you sure you want to decline?"
						okText="Yes"
						cancelText="No"
					>
						<Button className={'ActionButton'} key="decline">
							<i className="icons8-font icons8-cancel"></i> Decline
						</Button>
					</Popconfirm>
				</div>
			);
			const edit = (
				<AccessPermissionChecker name={PERMISSION_NAMES.EDIT_WORK_ORDERS}>
					<div className={'ActionWrapper'}>
						<Link
							className={'ActionLink'}
							to={getLinkWIthBackLinkParams(
								location,
								BACK_TEXT,
								`/supplier/workOrders/edit/${workOrder.id}`
							)}
						>
							<Button
								className={'ActionButton'}
								key="edit"
								icon={<i className="icons8-font icons8-font-margin-right icons8-edit" />}
							>
								Edit
							</Button>
						</Link>
					</div>
				</AccessPermissionChecker>
			);
			const startWork = (
				<AccessPermissionChecker name={PERMISSION_NAMES.REMOTE_CHECK_IN_OR_CHECK_OUT_ALLOWED}>
					<div className={'ActionWrapper'}>
						<Button
							className={'ActionButton'}
							key="startWork"
							onClick={this.withFullWorkOrder('startWork', (fullWorkOrder, e) => {
								e.stopPropagation();
								e.preventDefault();
								const { manualCheckIn } = this.props;
								const serviceCall = {
									workOrderId: fullWorkOrder.id,
									supplierFacilityId: fullWorkOrder.supplierFacilityId,
									serviceScheduledAt: moment(),
									leadTechnicianEmail: currentUser.email,
									additionalTechnicianEmails: [],
									stockLocationIds: [],
								};

								scheduleServiceCall(fullWorkOrder, serviceCall)
									.then((updatedWorkOrder) => {
										if (isCheckInModalMandatory(fullWorkOrder, currentUser)) {
											this.setState({ modal: 'manualCheckInFormVisible' });
										} else {
											if (nullSafeGet('contractorWo', fullWorkOrder)) {
												const lastServiceCall = nullSafeGetOrElse(
													'lastContractorServiceCall',
													updatedWorkOrder,
													{}
												);
												const updatedServiceCall = {
													...lastServiceCall,
													checkInByEmail: currentUser.email,
													checkInTime: moment(),
													checkInNotes: undefined,
													checkInPhotos: [],
												};
												return manualCheckInForContractor(updatedServiceCall).then(() => {
													message.success(`Work started.`);
													refreshTable(location);
												});
											} else {
												const lastServiceCall = nullSafeGetOrElse(
													'lastServiceCall',
													updatedWorkOrder,
													{}
												);
												const updatedServiceCall = {
													...lastServiceCall,
													checkInByEmail: currentUser.email,
													checkInTime: moment(),
													checkInNotes: undefined,
													checkInPhotos: [],
												};
												return manualCheckIn(updatedServiceCall).then(() => {
													message.success(`Work started.`);
												});
											}
										}
									})
									.finally(() => this.setState({ actionButtonLoading: null }));
							})}
							icon={<i className="icons8-font icons8-checkmark" />}
							loading={actionButtonLoading === 'startWork'}
							disabled={disabledByAnotherAction(actionButtonLoading, 'startWork')}
						>
							Start Work
						</Button>
					</div>
				</AccessPermissionChecker>
			);
			const schedule = (
				<div className={'ActionWrapper'}>
					<Button
						className={'ActionButton'}
						key="schedule"
						onClick={this.withFullWorkOrder('schedule', (fullWorkOrder, e) => {
							stopDefaultEvents(e);
							this.setState({ actionButtonLoading: null, modal: 'scheduleServiceCallFormVisible' });
						})}
						loading={actionButtonLoading === 'schedule'}
						disabled={disabledByAnotherAction(actionButtonLoading, 'schedule')}
					>
						<i className="icons8-font icons8-schedule"></i> Schedule
					</Button>
				</div>
			);
			const techEnRoute = (
				<div className={'ActionWrapper'}>
					<Button
						className={'ActionButton'}
						key="techEnRoute"
						loading={actionButtonLoading === 'techEnRoute'}
						disabled={disabledByAnotherAction(actionButtonLoading, 'techEnRoute')}
						onClick={(e) => {
							stopDefaultEvents(e);
							this.setState({ actionButtonLoading: 'techEnRoute' });
							techEnRouteWorkOrder(workOrder)
								.then(() => {
									message.success(`Tech marked as en route.`);
									refreshTable(location);
								})
								.catch(() => {
									message.error(`Something went wrong. Please try again.`);
								})
								.finally(() => {
									this.setState({ actionButtonLoading: null });
								});
						}}
					>
						<i className="icons8-font icons8-location-logo-2"></i> En Route
					</Button>
				</div>
			);

			const scheduleAndTechEnRoute = (
				<div className={'ActionWrapper'}>
					<Button
						className={'ActionButton'}
						key="scheduleAndTechEnRoute"
						loading={actionButtonLoading === 'scheduleAndTechEnRoute'}
						disabled={disabledByAnotherAction(actionButtonLoading, 'scheduleAndTechEnRoute')}
						onClick={(e) => {
							stopDefaultEvents(e);
							this.setState({ actionButtonLoading: 'scheduleAndTechEnRoute' });
							const serviceCall = {
								workOrderId: workOrder.id,
								supplierFacilityId: workOrder.supplierFacilityId,
								serviceScheduledAt: moment().toISOString(),
								leadTechnicianEmail: currentUser.email,
								additionalTechnicianEmails: [],
								stockLocationIds: [],
							};
							scheduleServiceCall(workOrder, serviceCall)
								.then(() => techEnRouteWorkOrder(workOrder))
								.then(() => {
									message.success(`Tech marked as en route.`);
									refreshTable(location);
								})
								.catch(() => {
									message.error(`Something went wrong. Please try again.`);
								})
								.finally(() => {
									this.setState({ actionButtonLoading: null });
								});
						}}
					>
						<i className="icons8-font icons8-location-logo-2"></i> En Route
					</Button>
				</div>
			);
			const reschedule = (
				<div className={'ActionWrapper'}>
					<Button
						className={'ActionButton'}
						key="reschedule"
						onClick={this.withFullWorkOrder('reschedule', (fullWorkOrder, e) => {
							stopDefaultEvents(e);
							this.setState({
								actionButtonLoading: null,
								modal: 'rescheduleServiceCallFormVisible',
							});
						})}
						loading={actionButtonLoading === 'reschedule'}
						disabled={disabledByAnotherAction(actionButtonLoading, 'reschedule')}
					>
						<i className="icons8-font icons8-rescheduling-a-task"></i> Reschedule
					</Button>
				</div>
			);
			const manualCheckIn = (
				<AccessPermissionChecker name={PERMISSION_NAMES.REMOTE_CHECK_IN_OR_CHECK_OUT_ALLOWED}>
					<div className={'ActionWrapper'}>
						<Button
							className={'ActionButton'}
							key="manualCheckIn"
							onClick={this.withFullWorkOrder('manualCheckIn', (fullWorkOrder, e) => {
								stopDefaultEvents(e);
								this.setState({ actionButtonLoading: null, modal: 'manualCheckInFormVisible' });
							})}
							loading={actionButtonLoading === 'manualCheckIn'}
							disabled={disabledByAnotherAction(actionButtonLoading, 'manualCheckIn')}
						>
							<i className="icons8-font icons8-checkmark"></i> Check In
						</Button>
					</div>
				</AccessPermissionChecker>
			);
			const manualCheckOut = (
				<AccessPermissionChecker name={PERMISSION_NAMES.REMOTE_CHECK_IN_OR_CHECK_OUT_ALLOWED}>
					<div className={'ActionWrapper'}>
						<Button
							className={'ActionButton'}
							key="manualCheckOut"
							onClick={this.withFullWorkOrder('manualCheckOut', (fullWorkOrder, e) => {
								stopDefaultEvents(e);
								this.setState({ actionButtonLoading: null, modal: 'manualCheckOutFormVisible' });
							})}
							loading={actionButtonLoading === 'manualCheckOut'}
							disabled={disabledByAnotherAction(actionButtonLoading, 'manualCheckOut')}
						>
							<i className="icons8-font icons8-checkout"></i> Check Out
						</Button>
					</div>
				</AccessPermissionChecker>
			);
			const transfer = (
				<div className={'ActionWrapper'}>
					<TransferWorkOrder
						workOrder={workOrder}
						buttonProps={{
							children: (
								<>
									<i
										className="icons8-font icons8-forward"
										style={{
											display: 'flex',
											left: '12px',
											position: 'absolute',
											alignItems: 'center',
											top: 8,
										}}
									/>
									Transfer
								</>
							),
							style: {
								display: 'flex',
								flexDirection: 'row',
								alignItems: 'center',
								justifyContent: 'center',
								width: '100%',
								flexGrow: 1,
								flexBasis: '80px',
								minWidth: '132px',
								paddingLeft: '28px',
							},
						}}
					/>
				</div>
			);
			const archive = (
				<div className={'ActionWrapper'}>
					<Button
						className={'ActionButton'}
						key="archive"
						danger
						ghost={true}
						onClick={(e) =>
							handleArchive(workOrder, e).then((e) => {
								refreshTable(location);
							})
						}
					>
						<i className="icons8-font icons8-trash-can"></i> Archive
					</Button>
				</div>
			);
			const privateOptions: any[] = isPrivateSupplier
				? [...[allowedToTransferWork ? transfer : []], ...[allowedToDenyWork ? decline : []]]
				: [];
			const publicOpenOptions = isPrivateSupplier ? [] : [accept, decline];

			if (differentAssignedSupplier) {
				switch (workOrder.displayStatus) {
					case 'Pending':
						if (workOrder.status === WORK_ORDER_STATUSES.supplierInitiatedPendingApproval) {
							return [edit];
						} else {
							return null;
						}
					case 'Open':
						return privateOptions;
					case 'InProgress':
						return privateOptions;
					case 'OnHold':
						return privateOptions;
					case 'Completed':
						return [archive];
					case 'Cancelled':
						return [archive];
					default:
						return null;
				}
			} else {
				switch (workOrder.displayStatus) {
					case 'Pending':
						if (workOrder.status === WORK_ORDER_STATUSES.supplierInitiatedPendingApproval) {
							return [edit];
						} else {
							return null;
						}
					case 'Open':
						if (SCHEDULE_TECH_STATUSES.includes(workOrder.status)) {
							return [
								schedule,
								isTechEnRouteEnabled ? scheduleAndTechEnRoute : null,
								startWork,
							].concat(privateOptions);
						} else {
							return publicOpenOptions.concat(privateOptions);
						}
					case 'InProgress':
						if (SCHEDULE_TECH_STATUSES.includes(workOrder.status)) {
							return [
								schedule,
								isTechEnRouteEnabled ? scheduleAndTechEnRoute : null,
								startWork,
							].concat(privateOptions);
						} else if (TECH_SCHEDULED_STATUSES.includes(workOrder.status)) {
							return [isTechEnRouteEnabled ? techEnRoute : null, reschedule, manualCheckIn].concat(
								privateOptions
							);
						} else if (workOrder.status === WORK_ORDER_STATUSES.techEnRoute) {
							return [reschedule, manualCheckIn].concat(privateOptions);
						} else if (workOrder.status === WORK_ORDER_STATUSES.techWorkingOnSite) {
							return [manualCheckOut].concat(privateOptions);
						} else {
							return privateOptions;
						}
					case 'OnHold':
						return privateOptions;
					case 'Completed':
						return [archive];
					case 'Cancelled':
						return [archive];
					default:
						return null;
				}
			}
		};

		const getLink = () => {
			const path = `/supplier/workOrders/detail/${nullSafeGet('id', record)}/details${
				targetCollectionName ? `?targetCollectionName=${targetCollectionName}` : ''
			}`;
			return getLinkWIthBackLinkParams(location, BACK_TEXT, path, {
				preserve: true,
			});
		};

		const { modal } = this.state;
		return (
			<>
				{modal === 'rescheduleServiceCallFormVisible' && (
					<ScheduleServiceCallModalForm
						formData={{
							...nullSafeGetOrElse('lastServiceCall', workOrder, {}),
							workOrder,
						}}
						isReschedule={true}
						wrappedComponentRef={this.saveFormRef('rescheduleServiceCallForm')}
						visible={modal === 'rescheduleServiceCallFormVisible'}
						onCancel={() => this.setState({ modal: null })}
						onSubmit={() => {
							const form = this.formRefs['rescheduleServiceCallForm'].props.form;
							form.validateFields((err, values) => {
								if (err) {
									return;
								}
								rescheduleServiceCall(workOrder, values).then(() => {
									this.setState({ modal: null });
									refreshTable(location);
									message.success(`Service call rescheduled.`);
								});
							});
						}}
					/>
				)}
				{modal === 'scheduleServiceCallFormVisible' && (
					<ScheduleServiceCallModalForm
						formData={{
							workOrder,
							supplierFacilityId: nullSafeGet('facility.id', currentUser),
						}}
						wrappedComponentRef={this.saveFormRef('scheduleServiceCallForm')}
						visible={modal === 'scheduleServiceCallFormVisible'}
						onCancel={() => this.setState({ modal: null })}
						onSubmit={() => {
							const form = this.formRefs['scheduleServiceCallForm'].props.form;
							form.validateFields((err, values) => {
								if (err) {
									return;
								}
								const timeZone =
									values['serviceScheduledAtTimeZone'] ||
									nullSafeGet('location.timeZoneId', workOrder);
								const formValues = {
									...values,
									serviceScheduledAt: formatDateForLocationTimeZone(
										values.serviceScheduledAt,
										timeZone
									),
								};

								scheduleServiceCall(workOrder, formValues).then(() => {
									this.setState({ modal: null });
									refreshTable(location);
									message.success(`Service call scheduled.`);
								});
							});
						}}
					/>
				)}
				{modal === 'declineWorkOrderFormVisible' && (
					<DeclineWorkOrderForm
						wrappedComponentRef={this.saveFormRef('declineWorkOrderForm')}
						visible={modal === 'declineWorkOrderFormVisible'}
						onCancel={() => this.setState({ modal: null })}
						onSubmit={(values) => {
							const { declineWorkOrder, declineWorkOrderPrivate, currentUser } = this.props;
							const declineRoute = isPrivateSupplier ? declineWorkOrderPrivate : declineWorkOrder;
							const workOrderFormData = {
								id: workOrder.id,
								...(values.note && {
									note: {
										text: values.note,
										noteAddedBy: currentUser.email,
										noteAddedAt: moment.utc(),
									},
								}),
							};
							declineRoute(workOrderFormData).then(() => {
								this.setState({ modal: null });
								message.success(`Work order declined`);
								refreshTable(location);
							});
						}}
					/>
				)}
				{modal === 'manualCheckInFormVisible' && (
					<ManualCheckInModalForm
						formData={nullSafeGetOrElse('lastServiceCall', workOrder, {})}
						workOrder={workOrder}
						wrappedComponentRef={this.saveFormRef('manualCheckInForm')}
						visible={modal === 'manualCheckInFormVisible'}
						onCancel={() => this.setState({ modal: null })}
						onSubmit={() => {
							const { manualCheckIn } = this.props;
							const form = this.formRefs['manualCheckInForm'].props.form;
							form.validateFields((err, values) => {
								if (err) {
									return;
								}
								// Destructure composite checkInNotes value from TextAreaWithAudio
								const { text: checkInNotes, audioUrl: checkInAudio } = values.checkInNotes || {};
								values.checkInNotes = checkInNotes;
								values.checkInAudio = checkInAudio;

								const timeZone =
									values['checkInTimeZone'] || nullSafeGet('location.timeZoneId', workOrder);
								const formValues = {
									...values,
									checkInTime: formatDateForLocationTimeZone(values.checkInTime, timeZone),
								};
								if (nullSafeGet('contractorWo', workOrder)) {
									manualCheckInForContractor(formValues).then(() => {
										this.setState({ modal: null });
										refreshTable(location);
										message.success(`Manually checked in.`);
									});
								} else {
									manualCheckIn(formValues).then(() => {
										this.setState({ modal: null });
										refreshTable(location);
										message.success(`Manually checked in.`);
									});
								}
							});
						}}
					/>
				)}
				{modal === 'manualCheckOutFormVisible' && (
					<ManualCheckOutModalForm
						workOrder={workOrder}
						formData={nullSafeGetOrElse('lastServiceCall', workOrder, {})}
						wrappedComponentRef={this.saveFormRef('manualCheckOutForm')}
						visible={modal === 'manualCheckOutFormVisible'}
						onCancel={() => this.setState({ modal: null })}
						onSubmit={() => {
							const { manualCheckOut } = this.props;
							const form = this.formRefs['manualCheckOutForm'].props.form;
							form.validateFields((err, values) => {
								if (err) {
									return;
								}
								// Destructure composite checkOutNotes value from TextAreaWithAudio
								const { text: checkOutNotes, audioUrl: checkOutAudio } = values.checkOutNotes || {};
								values.checkOutNotes = checkOutNotes;
								values.checkOutAudio = checkOutAudio;

								const timeZone =
									values['checkOutTimeZone'] || nullSafeGet('location.timeZoneId', workOrder);
								const checkOutTime = clampCheckOutToCheckIn(
									nullSafeGet('lastServiceCall.checkInTime', workOrder),
									formatDateForLocationTimeZone(values.checkOutTime, timeZone)
								);
								const formValues = {
									...values,
									checkOutTime,
								};
								if (nullSafeGet('contractorWo', workOrder)) {
									if (values.estimatedCompletionDate) {
										const newContractorWO = {
											id: nullSafeGet('contractorWo.id', workOrder),
											subEstimatedCompletionDate: values.estimatedCompletionDate.utc().format(),
										};
										updateSubContractorInfo(newContractorWO)
											.then(() => {
												this.setState({ modal: null });
												message.success(`Work order Updated`);
											})
											.then(() => {
												if (values.resolutionTypeId) {
													updateWorkOrderResolutionType(workOrder.id, values.resolutionTypeId).then(
														() => {
															manualCheckOutForContractor(formValues).then(() => {
																this.setState({ modal: null });

																refreshTable(location);
																message.success(`Manually checked out.`);
															});
														}
													);
												} else {
													manualCheckOutForContractor(formValues).then(() => {
														this.setState({ modal: null });

														refreshTable(location);
														message.success(`Manually checked out.`);
													});
												}
											});
									} else {
										if (values.resolutionTypeId) {
											updateWorkOrderResolutionType(workOrder.id, values.resolutionTypeId).then(
												() => {
													manualCheckOutForContractor(formValues).then(() => {
														this.setState({ modal: null });

														refreshTable(location);
														message.success(`Manually checked out.`);
													});
												}
											);
										} else {
											manualCheckOutForContractor(formValues).then(() => {
												this.setState({ modal: null });

												refreshTable(location);
												message.success(`Manually checked out.`);
											});
										}
									}
								} else {
									if (values.estimatedCompletionDate) {
										updateWorkOrderPartially(record.id, {
											estimatedCompletionDate: values.estimatedCompletionDate.utc().format(),
										})
											.then(() => {
												message.success(`Work order Updated`);
											})
											.then(() => {
												if (values.resolutionTypeId) {
													updateWorkOrderResolutionType(workOrder.id, values.resolutionTypeId).then(
														() => {
															manualCheckOut(formValues).then(() => {
																this.setState({ modal: null });
																refreshTable(location);
																message.success(`Manually checked out.`);
															});
														}
													);
												} else {
													manualCheckOut(formValues).then(() => {
														this.setState({ modal: null });
														refreshTable(location);
														message.success(`Manually checked out.`);
													});
												}
											});
									} else {
										if (values.resolutionTypeId) {
											updateWorkOrderResolutionType(workOrder.id, values.resolutionTypeId).then(
												() => {
													manualCheckOut(formValues).then(() => {
														this.setState({ modal: null });
														refreshTable(location);
														message.success(`Manually checked out.`);
													});
												}
											);
										} else {
											manualCheckOut(formValues).then(() => {
												this.setState({ modal: null });
												refreshTable(location);
												message.success(`Manually checked out.`);
											});
										}
									}
								}
							});
						}}
						privateSupplier={isPrivateSupplier}
					/>
				)}
				<Row className="index-row-wrapper group" style={{ display: 'flex', flexWrap: 'nowrap' }}>
					<Col
						style={{
							display: 'flex',
							flexGrow: 1,
							minWidth: 0,
							maxWidth: '100%',
							overflow: 'hidden',
						}}
					>
						<Link
							className="index-padding"
							style={{ width: '100%', minWidth: 0, display: 'flex', flexDirection: 'column' }}
							to={getLink()}
							draggable={false}
						>
							<WorkOrderRowDisplay workOrder={record} refreshTable={refreshTable} />
						</Link>
					</Col>
					<Col
						className={`ActionRow`}
						style={{
							gridTemplateColumns: `repeat(${
								nullSafeGetOrElse('length', getWorkOrderActions(), 2) > 1 ? 2 : 1
							}, auto[col-start])`,
							alignSelf: 'flex-start',
							flexShrink: 0,
						}}
					>
						{getWorkOrderActions()}
					</Col>
				</Row>
			</>
		);
	}
}

const mapStateToProps = (state) => ({
	isClientView: state.clientView.isClientView,
});

const mapDispatchToProps = (dispatch) => ({
	handleArchive: (entity) =>
		dispatch(workOrdersRestCrudThunksForSupplier.archive(entity, 'id', true)),
	unarchiveWorkOrder: (entity) =>
		dispatch(workOrdersRestCrudThunksForSupplier.unarchive(entity, 'id', true)),
	getFullWorkOrder: (id) => dispatch(workOrdersRestCrudThunksForSupplier.readOne(id)),
	scheduleServiceCall: (workOrder, serviceCall) =>
		nullSafeGet('contractorWo', workOrder)
			? dispatch(
					scheduleServiceCallForContractor({
						...serviceCall,
						contractorWorkOrderId: getContractorOrWorkOrderId(workOrder),
						supplierFacilityId: nullSafeGet('contractorWo.subSupplierFacilityId', workOrder),
						workOrderId: undefined,
					})
			  )
			: dispatch(scheduleServiceCallForSupplier(serviceCall)),

	rescheduleServiceCall: (workOrder, serviceCall) =>
		nullSafeGet('contractorWo', workOrder)
			? dispatch(
					rescheduleServiceCallForContractor({
						...serviceCall,
						contractorWorkOrderId: getContractorOrWorkOrderId(workOrder),
						supplierFacilityId: nullSafeGet('contractorWo.subSupplierFacilityId', workOrder),
						workOrderId: undefined,
					})
			  )
			: dispatch(rescheduleServiceCallForSupplier(serviceCall)),
	manualCheckIn: (serviceCall) => dispatch(manualCheckInServiceCallForSupplier(serviceCall)),
	manualCheckInForContractor: (serviceCall) =>
		dispatch(manualCheckInServiceCallForContractor(serviceCall)),
	manualCheckOut: (serviceCall) => dispatch(manualCheckOutServiceCallForSupplier(serviceCall)),
	manualCheckOutForContractor: (serviceCall) =>
		dispatch(manualCheckOutServiceCallForContractor(serviceCall)),
	declineWorkOrder: (entity) => dispatch(declineWorkOrderForSupplier(entity, 'id')),
	declineWorkOrderPrivate: (entity) => dispatch(declineWorkOrderForPrivateSupplier(entity, 'id')),
	acceptWorkOrder: (entity) => dispatch(acceptWorkOrderForSupplier(entity, 'id')),
	updateWorkOrderPartially: (id, entity) =>
		dispatch(workOrdersRestCrudThunksForSupplier.updatePartially(id, entity)),
	updateWorkOrderResolutionType: (workOrderId, resolutionTypeId) =>
		dispatch(updateWorkOrderResolutionTypeForSupplier(workOrderId, resolutionTypeId)),
	updateSubContractorInfo: (entity) => dispatch(updateContractWorkOrder(entity, 'id')),
	acceptContractorWorkOrder: (entity) => dispatch(acceptContractorWorkOrder(entity)),
	declineContractorWorkOrder: (entity) => dispatch(declineContractorWorkOrder(entity)),
	techEnRouteWorkOrder: (entity) =>
		nullSafeGet('contractorWo', entity)
			? dispatch(techEnRouteContractorWorkOrder(entity, 'subContractedFromWorkOrder'))
			: dispatch(techEnRouteServiceCallForSupplier(entity)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WorkOrderTableRow);
